import { useMemo } from "react";
import { Column, useExpanded, useTable } from "react-table";
import { Link, MaskCnpj } from "@funcional/react-ui";
import { IntlDateTime, IntlEnum } from "@funcional/react-intl-ui";
import { IProgramFamilyBeneficiary } from "@pbm/beneficiaries/contracts";
import { BeneficiaryFieldsList } from "./BeneficiaryFieldsList";
import { ReactTable } from "@funcional/react-table-ui";

interface ProgramFamilyBeneficiarysListProps {
  data: IProgramFamilyBeneficiary[];
  programCode: string;
}

interface CellProps {
  value: any;
  row: { original: IProgramFamilyBeneficiary };
}

export function ProgramFamilyBeneficiarysList({
  data,
  programCode,
}: ProgramFamilyBeneficiarysListProps) {
  const columns: Column<IProgramFamilyBeneficiary>[] = useMemo(
    () =>
      [
        {
          Header: "Código",
          accessor: "programFamily.code",
          Cell: ({ value }: CellProps) => (
            <Link to={`/pbm/programs/${programCode}/families/${value}`}>
              {value}
            </Link>
          ),
        },
        { Header: "Grupo de Produtos", accessor: "programFamily.name" },
        {
          Header: "Origem",
          accessor: "origin",
          Cell: ({ value }: any) => (
            <IntlEnum name="authorization_origin" value={value} />
          ),
        },
        {
          Header: "CNPJ",
          accessor: "storeCode",
          Cell: ({ value }: any) =>
            value ? <MaskCnpj value={value} /> : "Não informado",
        },
        {
          Header: "Data",
          accessor: "createdAt",
          Cell: ({ value }: any) => <IntlDateTime value={value} />,
        },
      ] as Column<IProgramFamilyBeneficiary>[],
    [programCode]
  );

  const renderSubComponent = (row: any) => {
    if (row?.original?.fields?.length > 0) {
      return <BeneficiaryFieldsList fields={row.original.fields} />;
    }

    return <p>Não há nenhum campo extra preenchido na inscrição.</p>;
  };

  const tableInstance = useTable({ columns, data }, useExpanded);

  return (
    <ReactTable
      renderSubComponent={renderSubComponent}
      tableInstance={tableInstance}
    />
  );
}
